<template>
  <div class="shedMenu">
    <!-- <div class="showVideo" @click="getStockPile">开启视频</div> -->
    <ul class="menuList">
      <li v-show="false">
        <a
          :class="{ menu_bar: true, selected: isCameraFllow }"
          @click="realShow()"
          >{{ !isCameraFllow ? "生产过程呈现" : "退出出生产过程" }}</a
        >
      </li>
      <li v-show="false">
        <a class="menu_bar">污染闭环治理呈现</a>
      </li>
      <li>
        <a
          :class="{ menu_bar: true, selected: subUl_visible }"
          @click="switchSubUrl()"
          >环保料棚数据监测</a
        >
        <ul style="margin-left: 50px" v-show="subUl_visible">
          <li>
            <a
              :class="{ menu_bar: true, selected: product_show_status }"
              @click="productShow()"
              >生产数据监测</a
            >
          </li>
          <li>
            <a
              :class="{ menu_bar: true, selected: tsp_show_status }"
              @click="tspShow()"
              >环境数据监测</a
            >
          </li>
          <li>
            <a
              :class="{ menu_bar: true, selected: govern_show_status }"
              @click="governShow()"
              >治理数据监测</a
            >
          </li>
          <li>
            <a
              :class="{ menu_bar: true, selected: camera_area_status }"
              @click="curVideoShow()"
              >现场视频监测</a
            >
          </li>
          <li v-if="isTestVideo">
            <a
              :class="{ menu_bar: true, selected: camera_area_status }"
              @click="getStockPile()"
              >视频</a
            >
          </li>
        </ul>
      </li>
      <li>
        <a
          :class="{ menu_bar: true, selected: subUl_visible }"
          @click="openPup()"
          >闭环管理历史查看</a
        >
      </li>
    </ul>
    <div ref="tspLineChart" class="tspEchart-detail" v-show="showVdm150"></div>
    <!-- <div ref="fogLineChart" class="fogEchart-detail" v-show="showFog"></div>  -->
    <div class="fgInfoBox" ref="fogLineChart" v-show="showFog">
      <div class="fgTitle">
        <div class="titleIcon"></div>
        <div>{{ foggunInfo.deviceName }}</div>
      </div>
      <div class="waterBox">
        <div class="wbLeft">
          <p>水</p>
          <p>量</p>
          <p>(t)</p>
        </div>
        <div class="wbRight">
          <div class="totalItem">
            <div>累积消耗</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 13"
                :class="[
                  item >
                  countBar(
                    foggunInfo.waterConsumption,
                    foggunInfo.saveWater,
                    13
                  )
                    ? 'itemBarNoYellow'
                    : 'itemBarYellow',
                ]"
                :key="item"
              ></div>
            </div>
            <div>{{ foggunInfo.waterConsumption }}</div>
          </div>
          <!-- <div class="totalItem"> 
            <div>累积节省</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 13"
                :class="[
                  item >
                  countBar(
                    foggunInfo.saveWater,
                    foggunInfo.waterConsumption,
                    13
                  )
                    ? 'itemBarNoBlue'
                    : 'itemBarBlue',
                ]"
                :key="item"
              ></div>
            </div>
            <div>{{ foggunInfo.saveWater }}</div>
          </div>-->
        </div>
      </div>
      <div class="waterBox electricBox">
        <div class="wbLeft">
          <p>电</p>
          <p>量</p>
          <p>(kwh)</p>
        </div>
        <div class="wbRight">
          <div class="totalItem">
            <div>累积消耗</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 13"
                :class="[
                  item >
                  countBar(
                    foggunInfo.powerConsumption,
                    foggunInfo.savePower,
                    13
                  )
                    ? 'itemBarNoYellow'
                    : 'itemBarYellow',
                ]"
                :key="item"
              ></div>
            </div>
            <div>{{ foggunInfo.powerConsumption }}</div>
          </div>
          <!-- <div class="totalItem">
            <div>累积节省</div>
            <div>
              <div
                class="itemBar"
                v-for="item in 13"
                :class="[
                  item >
                  countBar(
                    foggunInfo.savePower,
                    foggunInfo.powerConsumption,
                    13
                  )
                    ? 'itemBarNoBlue'
                    : 'itemBarBlue',
                ]"
                :key="item"
              ></div>
            </div>
            <div>{{ foggunInfo.savePower }}</div>
          </div> -->
        </div>
      </div>
      <div class="fgTitle chartTitle">
        <div class="titleIcon"></div>
        <div>本月运行时长</div>
      </div>
      <div class="mrTime">
        <div class="chart3" ref="chart3"></div>
      </div>
    </div>
    <div class="belt_pop" ref="beltLineChart" v-if="belt_show_status">
      <ul class="belt_pop_container">
        <li>
          <div class="li_title">
            <div class="li_icon"></div>
            <div class="li_name">皮带运行相关在线数据</div>
          </div>
          <div class="part_box">
            <div class="part1">
              <div class="left_p">设备编码</div>
              <div class="right_p">{{ deviceBasic.deviceNo }}</div>
            </div>
            <div class="part1">
              <div class="left_p">{{ deviceBasic.signalName }}</div>
              <div class="right_p">
                {{ deviceBasic.realTimeValue == 1 ? "开启" : "关闭" }}
                <!-- {{ deviceBasic.unit }} -->
              </div>
            </div>
            <div class="part1">
              <div class="left_p">更新时间</div>
              <div class="right_p">{{ deviceBasic.updateTime }}</div>
            </div>
          </div>
        </li>
        <li>
          <div class="li_title">
            <div class="li_icon"></div>
            <div class="li_name">小时运输量</div>
          </div>
          <div class="echart_box">
            <div class="chart1" ref="chart1"></div>
          </div>
        </li>
        <li>
          <div class="li_title">
            <div class="li_icon"></div>
            <div class="li_name">日运输量</div>
          </div>
          <div class="echart_box">
            <div class="chart2" ref="chart2"></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="vdmChart" v-if="showVdm100">
      <div class="vdmChartHead">
        <div>
          <div>设备编码：</div>
          <div>{{ vdmDeviceNo }}</div>
        </div>
        <div>
          <div>设备类型：</div>
          <div>{{ vdmType }}</div>
        </div>
      </div>
      <SingleVdm
        v-if="showVdm100"
        :deviceNo="vdmDeviceNo"
        :startTime="timeArr[0]"
        :endTime="timeArr[1]"
      />
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  switchAllEqmHL, //开关设备高亮
  switchCameraControl,
  backToLocationFun,
} from "@/assets/js/unity3D/shed.js";

import moment from "moment";
import { unwarp, getOpt } from "@/utils/tools.js";
import getBeltOpt from "./chartBar.js";
import SingleVdm from "@/modules/unorganizedComponents/vdmBar/singleVdm.vue";
import { dateFormat } from "@/utils/tools.js";
import iframePup from "@/modules/iframePup/iframePup.vue";
import { mapState, mapGetters } from "vuex";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';


export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SingleVdm },
  props: ["isCameraFllow"],
  inject: [
    "closeReal",
    "switchHL",
    "switchVideoArea",
    "updateNvrInfo",
    "getEquipCurStatus",
    "stopWarn",
    "switchCF",
  ],
  data() {
    //这里存放数据
    return {
      subUl_visible: false,
      showVdm150: false,
      showFog: false,
      vdm150Chart: null,
      showVdm100: false,
      fogChart: null,
      customerId: this.$store.state.customerId,
      isTestVideo: bmeConfig.isTestVideo,
      deviceBasic: {},
      chart1: null,
      chart2: null,
      chart3: null,
      belt_show_status: false,
      real_show_status: false,
      product_show_status: false,
      govern_show_status: false,
      tsp_show_status: false,
      camera_area_status: false,
      foggunInfo: {
        deviceName: "东侧南至北1#雾炮",
        status: "true",
        waterConsumption: 45,
        saveWater: 17,
        powerConsumption: 77,
        savePower: 17,
      },
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      vdmDeviceNo: "",
      vdmType: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    countBar() {
      return function (a, b, c) {
        return Math.round((a * c) / (a + b));
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeUnmount() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getShedVideoList();
    // this.getBeltAllData();
    this.$shedVdm150ClickFunc.cb = this.vdm150DataPopup;
    this.$shedBeltClickFunc.cb = this.getBeltAllData;
    this.$shedStockPileClickFunc.cb = this.getStockPile;
    this.$shedFogClickFunc.cb = this.waterSprayHistory;
    this.$shedVdm100ClickFunc.cb = this.shedVdm100Click;
    this.$shedVdm3500ClickFunc.cb = this.shedVdm3500Click;

    document.addEventListener("click", this.handleDocumentClick);

    // this.getEquipCurStatus();
  },
  //方法集合
  methods: {
    shedVdm100Click(shedID) {
      this.showVdm100 = true;
      if (shedID === "0,1,MaterialCar") {
        shedID = "0,3,VDM100";
      } else if (shedID === "1,1,MaterialCar") {
        shedID = "0,6,VDM100";
      } else if (shedID === "0,1,Scraper") {
        shedID = "0,7,VDM100";
      } else if (shedID === "1,1,Scraper") {
        shedID = "0,8,VDM100";
      }
      // console.log(shedID,this.$shedEquipRelate.data.vdm100)
      this.vdmDeviceNo =
        this.$shedEquipRelate.data.vdm100 &&
        this.$shedEquipRelate.data.vdm100[shedID];
      this.vdmType = shedID.split(",")[2] + "监测仪";
    },
    shedVdm3500Click(shedID) {
      this.showVdm100 = true;
      // console.log(shedID,this.$shedEquipRelate.data.vdm3500)
      this.vdmDeviceNo =
        this.$shedEquipRelate.data.vdm3500 &&
        this.$shedEquipRelate.data.vdm3500[shedID];
      this.vdmType = shedID.split(",")[2] + "监测仪";
    },
    async getShedVideoList() {
      let getShedVideoListUrl =
        CONFIG.requestShed + this.$apiOpt.findMaterialVideo;
      let mapResult = await this.$apiUtils.get(getShedVideoListUrl, {
        shedNo: "42_101",
      });
      if (mapResult) {
        this.shedVideoList = this.$shedEquipRelate.videoList =
          mapResult[0].list;
        // console.log(this.shedVideoList);
      }
    },
    curVideoShow() {
      //this.vdm150DataPopup("0,1,VDM150");
      //this.getBeltAllData();
      if (this.camera_area_status) {
        this.camera_area_status = false;
        switchAllEqmHL(false);
        this.switchVideoArea(false);
        this.getEquipCurStatus();
      } else {
        this.camera_area_status = true;
        this.tsp_show_status = false;
        this.product_show_status = false;
        this.govern_show_status = false;
        switchAllEqmHL(false);
        this.switchVideoArea(true);
        this.stopWarn();
      }
    },
    productShow() {
      if (this.product_show_status) {
        this.product_show_status = false;
        switchAllEqmHL(false);
        this.switchVideoArea(false);
        this.getEquipCurStatus();
      } else {
        this.product_show_status = true;
        this.govern_show_status = false;
        this.tsp_show_status = false;
        this.camera_area_status = false;
        this.switchVideoArea(false);
        this.switchHL(0);
        this.stopWarn();
      }
    },
    governShow() {
      if (this.govern_show_status) {
        this.govern_show_status = false;
        switchAllEqmHL(false);
        this.switchVideoArea(false);
        this.getEquipCurStatus();
      } else {
        this.govern_show_status = true;
        this.product_show_status = false;
        this.tsp_show_status = false;
        this.camera_area_status = false;
        this.switchVideoArea(false);
        this.switchHL(1);
        this.stopWarn();
      }
    },
    tspShow() {
      if (this.tsp_show_status) {
        this.tsp_show_status = false;
        switchAllEqmHL(false);
        this.switchVideoArea(false);
        this.getEquipCurStatus();
      } else {
        this.tsp_show_status = true;
        this.product_show_status = false;
        this.govern_show_status = false;
        this.camera_area_status = false;
        this.switchVideoArea(false);
        this.switchHL(2);
        this.stopWarn();
      }
    },
    //生产过程
    realShow() {
      if (this.isCameraFllow) {
        this.switchCF(false);
      } else {
        this.switchCF(true);
      }
    },
    handleDocumentClick(e) {
      console.log(e);
      let that = this;
      if (
        !that.showVdm150 ||
        !that.$refs.tspLineChart ||
        that.$refs.tspLineChart.contains(e.target)
      ) {
      } else {
        // that.vdm150Chart && unwarp(that.vdm150Chart).destory();
        that.showVdm150 = false;
      }

      if (
        !that.showFog ||
        !that.$refs.fogLineChart ||
        that.$refs.fogLineChart.contains(e.target)
      ) {
      } else {
        that.showFog = false;
        // unwarp(that.chart3) && unwarp(that.chart3).destory();
      }

      if (
        !that.belt_show_status ||
        !that.$refs.beltLineChart ||
        that.$refs.beltLineChart.contains(e.target)
      ) {
      } else {
        that.belt_show_status = false;
        // that.chart1 && unwarp(that.chart1).destory();
        // that.chart2 && unwarp(that.chart2).destory();
      }

      if (this.showVdm100) {
        this.showVdm100 = false;
      }
    },
    switchSubUrl() {
      if (this.subUl_visible) {
        this.subUl_visible = false;
        switchAllEqmHL(false);
        this.switchVideoArea(false);
        this.tsp_show_status = false;
        this.product_show_status = false;
        this.govern_show_status = false;
        this.camera_area_status = false;
        this.getEquipCurStatus();
      } else {
        this.subUl_visible = true;
      }
      this.$forceUpdate();
    },
    openPup() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog:
          "https://vis.bmetech.com/standard/vis/page/shedDialogRF/intelligentGover.html?customerId=42&sourceType=1&style=typeDark&id=1234567"+(window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
      });
    },
    async vdm150DataPopup(shedID) {
      let vdm150DeviceNo =
        /*"BMEVDM5J210502148";*/
        this.$shedEquipRelate.data.vdm150 &&
        this.$shedEquipRelate.data.vdm150[shedID];

      if (vdm150DeviceNo) {
        let findVdmDetailResultUrl =
          CONFIG.requestShed + this.$apiOpt.findVdmDetailResult;
        let vdmDetailResult = await this.$apiUtils.get(findVdmDetailResultUrl, {
          customerId: this.$store.state.customerId,
          deviceNo: vdm150DeviceNo,
          startTime: moment(new Date() - 24 * 3600 * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        });

        if (vdmDetailResult && vdmDetailResult.signalDetailList.length > 0) {
          let tspDataList = [];
          let timeArray = [];
          let unit = "";
          vdmDetailResult.signalDetailList.forEach((item) => {
            tspDataList.push(item.value ? item.value : 0);
            timeArray.push(
              moment(new Date(item.dateTime) - 24 * 3600 * 1000).format(
                "MM-DD HH:mm"
              )
            );
          });
          unit = vdmDetailResult.unit;
          let areaStyle = {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(251,218,2,0.52)",
              },
              {
                offset: 1,
                color: "rgba(251,218,2,0)",
              },
            ]),
          };
          let itemStyle = {
            normal: {
              color: "#00FF00",
            },
          };

          let seriesArray = {
            areaStyle: areaStyle,
            data: tspDataList,
            itemStyle: itemStyle,
            name: vdm150DeviceNo,
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            type: "line",
          };

          this.detailEchartsFun([vdm150DeviceNo], timeArray, seriesArray, unit);
        }
      }
    },
    detailEchartsFun(legendArray, timeArray, seriesArray, unit) {
      if (this.vdm150Chart) {
        console.log(unwarp(this.vdm150Chart));
        // unwarp(this.vdm150Chart) && unwarp(this.vdm150Chart).destory();
      }
      this.vdm150Chart = echarts.init(this.$refs.tspLineChart);
      let option = {
        tooltip: {
          backgroundColor: "black",
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          formatter: function (params) {
            //						console.log(params)
            var htmlStr = "";
            htmlStr +=
              '<div><span style="color:#fff;font-size:16px;">' +
              params[0].name +
              "</span><br/> ";
            for (var i = 0; i < params.length; i++) {
              let val = "";
              val = params[i].value
                ? params[i].value
                : params[i].value == 0
                ? 0
                : "暂无数据";
              //前面的原点和他的颜色
              htmlStr +=
                '<span style="width: 10px;height: 10px;display:inline-block;border-radius: 50%;background-color:' +
                params[i].color +
                '"></span><span style="color:#fff;font-size:16px;">' +
                params[i].seriesName +
                ":</span>" +
                '<span style="color:#fff;font-size:16px;">' +
                val +
                "&nbsp;" +
                unit +
                "</span><br/>";
            }
            htmlStr += "</div>";
            return htmlStr;
          },
        },
        legend: {
          type: "scroll",
          right: "15%",
          data: legendArray,
          textStyle: {
            color: "rgba(255,255,255,1)",
            fontSize: 16,
          },
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            //					data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            data: timeArray,
            axisLabel: {
              show: true,
              /*X轴上的字段*/
              textStyle: {
                color: "#FFFFFF",
                fontSize: 16,
              },
              // interval: 3,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.15)",
                /*X轴的坐标线*/
                type: "solid",
                width: 1,
              },
            },

            splitLine: {
              show: true,
              lineStyle: {
                color: "red",
                type: "dotted",
                width: 0,
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            show: true,
            axisLabel: {
              show: true,
              /*X轴上的字段*/
              textStyle: {
                color: "rgba(225,225,225,0.5)",
                fontSize: 16,
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              // 轴线
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.15)",
                /*X轴的坐标线*/
                type: "solid",
                width: 1,
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.05)",
                type: "solid",
                width: 1,
              },
            },
            scale: true,
          },
        ],
        series: seriesArray,
      };
      this.$forceUpdate();
      this.showVdm150 = true;
      this.$nextTick(() => {
        // 为echarts对象加载数据
        unwarp(this.vdm150Chart).setOption(option);
      });
    },
    async waterSprayHistory(shedID) {
      let fogDeviceNo =
        /*"BMEVDM5J210502148";*/
        this.$shedEquipRelate.data.fog &&
        this.$shedEquipRelate.data.fog[shedID];

      let waterSprayHistoryUrl =
        CONFIG.requestShed + this.$apiOpt.waterSprayHistory;
      let fogDetailResult = await this.$apiUtils.get(waterSprayHistoryUrl, {
        customerId: this.$store.state.customerId,
        deviceNo: fogDeviceNo,
      });
      let { runningTimeList, ...fogDetail } = fogDetailResult;
      for (let i in fogDetail) {
        if (fogDetail[i] === "--") {
          fogDetail[i] = 0;
        }
      }
      this.foggunInfo = fogDetail;
      this.$forceUpdate();
      this.showFog = true;
      this.$nextTick(() => {
        if (runningTimeList) {
          if (this.chart3) {
            unwarp(this.chart3) && unwarp(this.chart3).destory?.destory();
          }
          this.chart3 = echarts.init(this.$refs.chart3);
          let echartData = {
            xdata: [],
            ydata: [],
            yName: "运行时长",
          };
          // console.log(runningTimeList);
          runningTimeList.forEach((i) => {
            echartData.xdata.push(i.date);
            echartData.ydata.push(i.runningTime);
          });

          unwarp(this.chart3).setOption(getBeltOpt(echartData));
        }
      });
      // this.$forceUpdate();
      // this.$nextTick(() => {
      //   this.fogDetailEchartsFun(
      //     [fogDeviceNo + "历史耗水量"],
      //     timeArray,
      //     seriesArray,
      //     unit
      //   );
      // });
    },
    getStockPile(id = "0,2") {
      if (this.camera_area_status || this.isTestVideo) {
        this.$store.commit("changeVideoPlayerSwitch", "open");
        let videoObj = this.shedVideoList.filter((i) => {
          return id.indexOf(i.frontId.substr(0, 3)) > -1;
        })[0];
        this.updateNvrInfo(videoObj);
      }
      // console.log(this.shedVideoList);
    },
    // getStockPile() {
    //   // console.log(this.shedVideoList);
    //   let id = '0,1,VideoArea'
    //   this.$store.commit("changeVideoPlayerSwitch", "open");
    //   let videoObj = this.shedVideoList.filter((i) => {
    //     return id.indexOf(i.frontId.substr(0, 3)) > -1;
    //   })[0];
    //   this.updateNvrInfo(videoObj);
    // },
    getBeltAllData(shedID) {
      let beltDeviceNo =
        // "RF-SC-YL-002";
        this.$shedEquipRelate.data.belt &&
        this.$shedEquipRelate.data.belt[shedID.substr(0, 4) + "Belt"];
      if (!beltDeviceNo) {
        return;
      }
      let findRealBelt = CONFIG.requestShed + this.$apiOpt.findRealBelt; //皮带运行相关数据
      let transportationVolume_hour =
        CONFIG.requestShed + this.$apiOpt.transportationVolume_hour; //小时运输量
      let transportationVolume_day =
        CONFIG.requestShed + this.$apiOpt.transportationVolume_day; //日运输量
      let p1 = this.$apiUtils.get(findRealBelt, {
        customerId: this.customerId,
        deviceNo: beltDeviceNo,
      });
      let p2 = this.$apiUtils.get(transportationVolume_hour, {
        customerId: this.customerId,
        deviceNo: beltDeviceNo,
      });
      let p3 = this.$apiUtils.get(transportationVolume_day, {
        customerId: this.customerId,
        deviceNo: beltDeviceNo,
      });

      Promise.all([p1, p2, p3])
        .then((result) => {
          console.log("返回数据", result); //['成功了', 'success']
          this.belt_show_status = true;
          this.$forceUpdate();
          this.$nextTick(() => {
            if (result[0]) {
              this.deviceBasic = result[0]?.deviceBasic[0];
            }
            if (result[1]) {
              if (this.chart1) {
                unwarp(this.chart1) && unwarp(this.chart1).destory?.destory();
              }
              this.chart1 = echarts.init(this.$refs.chart1);
              let echartData = {
                xdata: [],
                ydata: [],
              };
              echartData.xdata = Object.keys(result[1]);
              // console.log(Object.keys(result[1]));
              echartData.xdata.forEach((i) => {
                let value = result[1][i] ? Number(result[1][i]).toFixed(2) : 0;
                echartData.ydata.push(value);
              });

              unwarp(this.chart1).setOption(getBeltOpt(echartData));
            }
            if (result[2]) {
              if (this.chart2) {
                unwarp(this.chart2) && unwarp(this.chart2).destory?.destory();
              }
              this.chart2 = echarts.init(this.$refs.chart2);
              let echartData = {
                xdata: [],
                ydata: [],
              };
              result[2].forEach((i) => {
                let time = i.dayTime ? i.dayTime.slice(0, 10) : "";
                let value = i.weight ? Number(i.weight).toFixed(2) : 0;
                echartData.xdata.push(time);
                echartData.ydata.push(value);
              });

              unwarp(this.chart2).setOption(getBeltOpt(echartData));
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.menu_bar {
  position: relative;
  width: 270px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  margin: 10px 20px;
  font-family: "fontNormal";
  background-image: url("img/unselected.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: inline-block;
  font-size: 26px;
  pointer-events: all;
}

.selected {
  background-image: url("img/selected.png") !important;
}

.menu_bar:hover {
  background-image: url("img/selected.png");
}

.tspEchart-detail {
  position: absolute !important;
  padding: 10px 20px;
  height: 220px;
  left: calc(50% + 140px);
  top: calc(50% - 110px);
  width: 640px;
  pointer-events: all;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 15px;
}

.fogEchart-detail {
  position: absolute !important;
  padding: 10px 20px;
  height: 220px;
  left: calc(50% + 80px);
  top: calc(50% - 110px);
  width: 640px;
  pointer-events: all;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 15px;
}

.shedMenu {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 120px;
  left: 50px;
  pointer-events: none;
  .showVideo {
    font-size: 28px;
    color: black;
    z-index: 999;
  }
  .menuList {
    display: flex;
    flex-direction: column;
  }
}

.vdmChart {
  padding: 30px 10px;
  width: 1200px;
  height: 700px;
  position: absolute;
  transform: scale(0.7);
  left: 2000px;
  top: 170px;
  background: black;
  background-color: rgba(7, 13, 13, 0.9);
  // background: url("./img/roadvdm2.png") no-repeat;
  background-size: cover;
  border: 3px solid rgba(50, 152, 223, 0.9);
  .vdmChartHead {
    margin-left: 20px;
    font-size: 28px;
    display: flex;
    > div {
      margin-right: 30px;
      display: flex;
      > div:nth-child(1) {
        color: rgb(205, 212, 224);
      }
    }
  }
}
.belt_pop {
  // width: 419px;
  // height: 648px;
  @include bg-box(419px, 648px, "belt_bg.png");
  background-color: "rgba(0,0,0,0.8)";
  pointer-events: all;
  position: fixed;
  top: 15%;
  left: 30%;
  margin-left: -375px;
  overflow: hidden;
  padding: 10px;
  & > ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    li {
      height: 212px;
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      .li_title {
        display: flex;
        align-items: center;
        .li_icon {
          @include bg-box(5px, 5px, "belt_icon.png");
        }
        .li_name {
          margin-left: 8px;
          width: 180px;
          height: 18px;
          font-size: 18px;
          color: #ffffff;
          line-height: 18px;
        }
      }
      .part_box {
        margin: 20px;
        height: 153px;
        background: rgba(74, 144, 226, 0.06);
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.82);
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .part1 {
          display: flex;
          justify-content: space-between;
          font-size: 25px;
          padding: 0px 10px;
          height: 36px;
          background: linear-gradient(
            225deg,
            rgba(195, 213, 255, 0.2) 0%,
            rgba(9, 26, 67, 0.31) 100%,
            #0049fa 100%
          );
          border: 1px solid rgba(0, 0, 0, 0.5);
          .left_p {
            height: 16px;
            font-size: 16px;
            color: #ffffff;
            line-height: 36px;
          }
          .right_p {
            @extend .left_p;
            color: #f5a623;
          }
        }
      }
      .echart_box {
        width: calc(100% - 40px);
        height: 153px;
        margin: 20px auto 0;
        z-index: 1;
        overflow: hidden;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid rgba(0, 0, 0, 0.82);
        background: rgba(3, 1, 30, 0.45);
      }
      .chart1 {
        height: 100%;
        width: 100%;
        z-index: 1;
      }
      .chart2 {
        height: 100%;
        width: 100%;
        z-index: 1;
      }
    }
  }
}
.fgInfoBox {
  width: 419px;
  height: 522px;
  background: url("./img/fgbg.png") no-repeat 100%;
  position: absolute;
  left: 58%;
  top: 10%;
}
.fgTitle {
  position: absolute;
  top: 8px;
  left: 12px;
  display: flex;
  align-items: center;
}
.fgTitle > div:nth-child(2) {
  font-size: 18px;
}
.titleIcon {
  width: 5px;
  height: 5px;
  background: url("./img/belt_icon.png") no-repeat 100%;
  margin-right: 10px;
}
.waterBox {
  width: 359px;
  height: 100px;
  position: absolute;
  background: url("./img/fgbox.png") no-repeat 100%;
  left: 25px;
  top: 45px;
  display: flex;
}
.electricBox {
  left: 25px;
  top: 165px;
}
.wbLeft {
  width: 45px;
  padding: 10px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.wbLeft p {
  color: rgba(173, 216, 255, 1);
}
.wbLeft > :nth-child(3) {
  font-size: 14px;
}
.wbRight {
  width: 314px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 28px 25px;
}
.totalItem {
  width: 274px;
  height: 47px;
  display: flex;
  align-items: center;
}
.totalItem div {
  text-align: center;
}
.totalItem > div:nth-child(1) {
  width: 100px;
  font-size: 18px;
}
.totalItem > div:nth-child(2) {
  width: 117px;
  height: 47px;
  display: flex;
  flex-wrap: nowrap;
}
.totalItem > div:nth-child(3) {
  width: 60px;
  text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.32);
}
.itemBar {
  width: 11px;
  height: 47px;
  background-repeat: no-repeat;
  background-size: cover;
}
.itemBarYellow {
  background-image: url("./img/fgitem1.png");
}
.itemBarNoYellow {
  background-image: url("./img/fgitem11.png");
}
.itemBarBlue {
  background-image: url("./img/fgitem2.png");
}
.itemBarNoBlue {
  background-image: url("./img/fgitem22.png");
}
.chartTitle {
  top: 290px;
}
.mrTime {
  position: absolute;
  top: 325px;
  left: 25px;
  width: 359px;
  height: 153px;
  z-index: 1;
  overflow: hidden;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid rgba(0, 0, 0, 0.82);
  background: rgba(3, 1, 30, 0.45);
}
.chart3 {
  width: 100%;
  height: 100%;
}
</style> 
